import { useContext, useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import ReactInputVerificationCode from "react-input-verification-code";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../routing/LangRouter";
import { useSearchParams } from "react-router-dom";

//import general components
import { BaseButton } from "../../components/common/base-button/base-button";
import BaseTextField from "../../components/common/base-text-field/base-text-field";

//import styles
import "./signIn.scss";

function VerificationCode({ loading, confirmVerificationCode, resendOtpCode, username, setIsSignInView, isNewUser }) {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);
    const [searchParams] = useSearchParams();
    const referralWithLink = searchParams.get("referral_code");

    const [verificationCode, setVerificationCode] = useState(""); // State to hold the verification code input by the user
    const [expirationTime, setExpirationTime] = useState(Date.now() + 120000); // State to track the expiration time of the verification code

    const [friendsIntroductionValues, setFriendsIntroductionValues] = useState({
        representativeCode: referralWithLink || null,
        instagramId: null,
    });

    const handleCodeChange = event => {
        const { name, value } = event.target;
        setFriendsIntroductionValues(values => ({ ...values, [name]: value }));
    };

    const resetVerificationProcess = () => {
        resendOtpCode();
        setVerificationCode("");
        setExpirationTime(Date.now() + 120000);
    };

    // Random component
    const Completionist = () => (
        <span className="signIn__edit-number" onClick={resetVerificationProcess}>
            {t("resendCode")}
        </span>
    );

    // Renderer callback with condition
    const renderCountdown = ({ minutes, seconds, completed }) =>
        completed ? (
            <Completionist />
        ) : (
            <span className="signIn__code-sent-to">
                {minutes}:{seconds}
            </span>
        );

    const [isDisable, setIsDisable] = useState(true);
    useEffect(() => {
        if (!!verificationCode && verificationCode.length === 6) {
            if (
                (friendsIntroductionValues.representativeCode && friendsIntroductionValues.instagramId) ||
                (!friendsIntroductionValues.representativeCode && !friendsIntroductionValues.instagramId)
            ) {
                setIsDisable(false);
            } else {
                setIsDisable(true);
            }
        }
    }, [verificationCode, friendsIntroductionValues]);

    return (
        <Grid
            className="signIn"
            component="form"
            onSubmit={event => confirmVerificationCode(event, verificationCode, friendsIntroductionValues)}
            container
            item
            xs={12}
            rowGap={4}
            justifyContent="center"
        >
            <Grid container item xs={12} justifyContent="space-between">
                <span className="signIn__code-sent-to">
                    {t("A message has been sent to")}: {username}
                </span>
                <span className="signIn__edit-number" onClick={() => setIsSignInView(true)}>
                    {t("edit")}
                </span>
            </Grid>

            <Grid
                className="signIn__verification-code"
                container
                item
                xs={12}
                rowGap={2}
                justifyContent={{ xs: "center", md: locale === "en" ? "flex-start" : "flex-end" }}
            >
                <span className="signIn__title">{t("verificationCodeTitle")}:</span>
                <div style={{ width: '100%', maxWidth: '400px', overflow: 'hidden' }}>
                <ReactInputVerificationCode onChange={setVerificationCode} value={verificationCode} length={6} placeholder="" autoFocus />
                </div>
            </Grid>
            {isNewUser && (
                <Grid container item xs={12} justifyContent="space-between">
                    <Grid container item xs={5.9}>
                        <BaseTextField
                            label={t("General.Referral Code")}
                            radius="0.625rem"
                            name="representativeCode"
                            value={friendsIntroductionValues?.representativeCode}
                            setValue={handleCodeChange}
                            error={!friendsIntroductionValues?.representativeCode && friendsIntroductionValues?.instagramId}
                            disabled={!!referralWithLink}
                        />
                    </Grid>
                    <Grid container item xs={5.9}>
                        <BaseTextField
                            label={t("General.Instagram ID")}
                            radius="0.625rem"
                            name="instagramId"
                            value={friendsIntroductionValues?.instagramId}
                            setValue={handleCodeChange}
                            error={friendsIntroductionValues?.representativeCode && !friendsIntroductionValues?.instagramId}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container item xs={12} rowGap={1} justifyContent={{ xs: "center", md: "flex-end" }}>
                <Grid className="signIn__timer" container item xs={12} md={4} justifyContent="center" alignItems="center" order={{ xs: 2, md: 1 }}>
                    {loading.getCode ? (
                        <CircularProgress color="inherit" size={20} />
                    ) : (
                        <Countdown renderer={renderCountdown} date={expirationTime} />
                    )}
                </Grid>
                <Grid container item xs={8} md={4} order={{ xs: 1, md: 2 }}>
                    <BaseButton
                        text={t("signin")}
                        color="primary"
                        size="medium"
                        radius="radius-10"
                        loading={loading.confirmCode}
                        type="submit"
                        disabled={isDisable}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default VerificationCode;
